module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAeElEQVQ4jWN89+7d/wcPHjD8/v2bAR84f/48hmxYWBgD47lz5/7LyckxcHNz4zVg4cKFWMWZQDYT0owPsCDLXbp0CatSPT09nEYwkW01FKC4AJ9N9HHBaBgM2TBgZWVl+Pr1K1m2m5mZMbAoKCgwEJOdsQEFBQUGAKAYKk5Mym9SAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Right_ico.png
// module id = H8Aq
// module chunks = 1